import { useAppContext } from "../../../AppProvider";

export const useListProps = () => {
  const { dictionary } = useAppContext();
  return {
    path: "/logistic-service/order-details",
    title: <h3>{dictionary.products.products}</h3>,
    pagination: { enabled: false, page: 0, size: 200 },
    selectRowsEnabled: { enabled: false },
    actionBar: { enabled: false },
    sorting: [
      {
        orderBy: "desc",
        column: "article.shippingRequired",
        isDefault: true,
      },
    ],
  };
};
